/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DataField {
    GEOMETRY = 'Geometry',
    SIMPLE_GEOMETRY = 'SimpleGeometry',
    NVDB_REFERENCES = 'NvdbReferences',
    GEOMETRY_Z = 'GeometryZ',
}
